// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-date-input {
  max-width: 10rem;
  font-size: 16px;
  padding: 0.65rem 0.75rem;
  padding-right: 2.5rem;
  border-radius: 0.25rem;
  outline: none;
  border: 1px solid var(--Gray-2, #7e8081);
}

.form-date-input {
  max-width: 10rem;
  font-size: 16px;
  padding: 0.5rem 0.75rem;
  padding-right: 1rem;
  border-radius: 0.25rem;
  outline: none;
  border-width: 1px;
  border-style: solid;
  border-color: #bdbdbc;
  transition: border-color 0.2s ease-in-out;
}

.form-date-input.error {
  border-color: #e83c4e;
}

.form-date-input.fill {
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}

.w-full {
  width: 100%;
}
.project-form-date-input {
  width: 211px;
  font-size: 16px;
  padding: 0.5rem 0.5rem;
  border-radius: 0.25rem;
  outline: none;
  border-width: 1px;
  border-style: solid;
  border-color: #b5b5b5;
  transition: border-color 0.2s ease-in-out;
}
.project-form-date-input-no-outline {
  width: 211px;
  font-size: 16px;
  padding: 0.5rem 0.5rem;
  border-radius: 0.25rem;
  outline: none;
  border:none;
}

.project-form-date-input.error {
  border-color: #e83c4e;
}
.subscription-form-date-input {
  width: 211px;
  font-size: 16px;
  padding: 0.5rem 0.5rem;
  border-radius: 0.25rem;
  outline: none;
  border-width: 1px;
  border-style: solid;
  border-color: #b5b5b5;
  transition: border-color 0.2s ease-in-out;
}

.subscription-form-date-input.error {
  border-color: #e83c4e;
}

.custom-date-input__icon {
  position: absolute;
  right: 10px;
  top: 7px;
}

.react-datepicker__header__dropdown {
  margin-top: 0.75rem;
}

.react-datepicker__month-read-view--selected-month,
.react-datepicker__year-read-view--selected-year {
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/custom-date-input.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB","sourcesContent":[".custom-date-input {\r\n  max-width: 10rem;\r\n  font-size: 16px;\r\n  padding: 0.65rem 0.75rem;\r\n  padding-right: 2.5rem;\r\n  border-radius: 0.25rem;\r\n  outline: none;\r\n  border: 1px solid var(--Gray-2, #7e8081);\r\n}\r\n\r\n.form-date-input {\r\n  max-width: 10rem;\r\n  font-size: 16px;\r\n  padding: 0.5rem 0.75rem;\r\n  padding-right: 1rem;\r\n  border-radius: 0.25rem;\r\n  outline: none;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-color: #bdbdbc;\r\n  transition: border-color 0.2s ease-in-out;\r\n}\r\n\r\n.form-date-input.error {\r\n  border-color: #e83c4e;\r\n}\r\n\r\n.form-date-input.fill {\r\n  max-width: 100%;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.w-full {\r\n  width: 100%;\r\n}\r\n.project-form-date-input {\r\n  width: 211px;\r\n  font-size: 16px;\r\n  padding: 0.5rem 0.5rem;\r\n  border-radius: 0.25rem;\r\n  outline: none;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-color: #b5b5b5;\r\n  transition: border-color 0.2s ease-in-out;\r\n}\r\n.project-form-date-input-no-outline {\r\n  width: 211px;\r\n  font-size: 16px;\r\n  padding: 0.5rem 0.5rem;\r\n  border-radius: 0.25rem;\r\n  outline: none;\r\n  border:none;\r\n}\r\n\r\n.project-form-date-input.error {\r\n  border-color: #e83c4e;\r\n}\r\n.subscription-form-date-input {\r\n  width: 211px;\r\n  font-size: 16px;\r\n  padding: 0.5rem 0.5rem;\r\n  border-radius: 0.25rem;\r\n  outline: none;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-color: #b5b5b5;\r\n  transition: border-color 0.2s ease-in-out;\r\n}\r\n\r\n.subscription-form-date-input.error {\r\n  border-color: #e83c4e;\r\n}\r\n\r\n.custom-date-input__icon {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 7px;\r\n}\r\n\r\n.react-datepicker__header__dropdown {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.react-datepicker__month-read-view--selected-month,\r\n.react-datepicker__year-read-view--selected-year {\r\n  margin-right: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
